/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Apikey_Title1Inputs */

const id_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manajemen Kunci API`)
};

const ms_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengurusan Kunci API`)
};

const da_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Nøgleadministration`)
};

const de_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüssel-Verwaltung`)
};

const en_us2_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key Management`)
};

const es_es2_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administración de clave de API`)
};

const es_mx2_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administración de API Key`)
};

const fil_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pamamahala ng API Key`)
};

const fr_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion de la clé API`)
};

const it_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestione chiave API`)
};

const hu_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API kulcs kezelés`)
};

const nl_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-sleutelbeheer`)
};

const no_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-nøkkeladministrasjon`)
};

const pl_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarządzanie kluczem API`)
};

const pt_br2_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key Management`)
};

const pt_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestão da Chave de API`)
};

const ro_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionare cheie API`)
};

const fi_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-avaimen hallinta`)
};

const sv_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-nyckelhantering`)
};

const vi_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quản lý khóa API`)
};

const tr_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Anahtar Yönetimi`)
};

const cs_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Správa API klíče`)
};

const bg_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление на API ключ`)
};

const ru_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление API-ключом`)
};

const uk_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Керування API-ключем`)
};

const ar_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إدارة مفتاح API`)
};

const hi_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API कुंजी प्रबंधन`)
};

const th_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การจัดการคีย์ API`)
};

const ja_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API キー管理`)
};

const zh_cn2_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key Management`)
};

const zh_hant1_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key Management`)
};

const ko_notifications_apikey_title1 = /** @type {(inputs: Notifications_Apikey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key Management`)
};

/**
* | output |
* | --- |
* | "API Key Management" |
*
* @param {Notifications_Apikey_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_apikey_title1 = /** @type {((inputs?: Notifications_Apikey_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Apikey_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_apikey_title1(inputs)
	if (locale === "ms") return ms_notifications_apikey_title1(inputs)
	if (locale === "da") return da_notifications_apikey_title1(inputs)
	if (locale === "de") return de_notifications_apikey_title1(inputs)
	if (locale === "en-US") return en_us2_notifications_apikey_title1(inputs)
	if (locale === "es-ES") return es_es2_notifications_apikey_title1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_apikey_title1(inputs)
	if (locale === "fil") return fil_notifications_apikey_title1(inputs)
	if (locale === "fr") return fr_notifications_apikey_title1(inputs)
	if (locale === "it") return it_notifications_apikey_title1(inputs)
	if (locale === "hu") return hu_notifications_apikey_title1(inputs)
	if (locale === "nl") return nl_notifications_apikey_title1(inputs)
	if (locale === "no") return no_notifications_apikey_title1(inputs)
	if (locale === "pl") return pl_notifications_apikey_title1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_apikey_title1(inputs)
	if (locale === "pt") return pt_notifications_apikey_title1(inputs)
	if (locale === "ro") return ro_notifications_apikey_title1(inputs)
	if (locale === "fi") return fi_notifications_apikey_title1(inputs)
	if (locale === "sv") return sv_notifications_apikey_title1(inputs)
	if (locale === "vi") return vi_notifications_apikey_title1(inputs)
	if (locale === "tr") return tr_notifications_apikey_title1(inputs)
	if (locale === "cs") return cs_notifications_apikey_title1(inputs)
	if (locale === "bg") return bg_notifications_apikey_title1(inputs)
	if (locale === "ru") return ru_notifications_apikey_title1(inputs)
	if (locale === "uk") return uk_notifications_apikey_title1(inputs)
	if (locale === "ar") return ar_notifications_apikey_title1(inputs)
	if (locale === "hi") return hi_notifications_apikey_title1(inputs)
	if (locale === "th") return th_notifications_apikey_title1(inputs)
	if (locale === "ja") return ja_notifications_apikey_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_apikey_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_apikey_title1(inputs)
	return ko_notifications_apikey_title1(inputs)
});
export { notifications_apikey_title1 as "notifications.apiKey.title" }